import React from 'react';
import { Chip } from '@mui/material';
import { colors, radius } from '../design-system/tokens';

const STATUS_TONES = {
  success: colors.status.success,
  active: colors.status.success,
  paid: colors.status.success,
  failed: colors.status.danger,
  danger: colors.status.danger,
  pending: colors.status.warning,
  warning: colors.status.warning,
  refund: colors.status.info,
  refunded: colors.status.info,
  blocked_qa: colors.qa,
  neutral: colors.status.neutral,
};

const PaymentStatusBadge = ({ label, status = 'neutral', sx }) => {
  const tone = STATUS_TONES[status] || colors.status.neutral;

  return (
    <Chip
      size="small"
      label={label}
      sx={{
        height: 24,
        maxWidth: '100%',
        borderRadius: `${radius.pill}px`,
        px: 0.25,
        bgcolor: tone.bg,
        color: tone.fg,
        border: `1px solid ${tone.border || colors.border.soft}`,
        fontSize: 12,
        fontWeight: 700,
        '& .MuiChip-label': {
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        ...sx,
      }}
    />
  );
};

export default PaymentStatusBadge;
